import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-project-summary-update" }
const _hoisted_2 = ["href", "title"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      href: $props.projectUpdateUrl,
      title: $props.title,
      class: "gfu-bt gfu-bt--b2 _line-clamp _line-clamp-2"
    }, [
      _createElementVNode("strong", null, _toDisplayString(_ctx.Resources.ProjectHome.ProjectSummaryBoxLastUpdate), 1 /* TEXT */),
      _createTextVNode(" " + _toDisplayString($props.title), 1 /* TEXT */)
    ], 8 /* PROPS */, _hoisted_2)
  ]))
}